// Re-export from @wander/shared + configure web auth bridge
import { configureValidationApi } from '@wander/shared/utils/itineraryValidation.js';

export * from '@wander/shared/utils/itineraryValidation.js';

// Configure authenticated fetch for web (adds Bearer token from Supabase session)
const authenticatedFetch = async (url, options = {}) => {
  const headers = { ...options.headers };
  try {
    const { getSession } = await import('../lib/supabase');
    const session = await getSession();
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
  } catch { /* proceed without auth */ }
  return fetch(url, { ...options, headers });
};

configureValidationApi(authenticatedFetch);
